import { drawImageToCanvas, getImageDimensions, getImageType } from '@/utils/image'

export async function resize(file: File | string, size = 1500) {
  const imageRect = await getImageDimensions(file)
  const contentType = await getImageType(imageRect.image)
  // 上传的图片尺寸太大，重新修改图片尺寸
  if (imageRect.width > imageRect.height) {
    const resizeWidth = size
    const scale = size / imageRect.width
    const resizeHeight = imageRect.height * scale
    const canvas = await drawImageToCanvas(imageRect.image, {
      canvasWidth: resizeWidth,
      canvasHeight: resizeHeight
    })
    return canvas.toDataURL(contentType)
  } else {
    const resizeHeight = size
    const scale = size / imageRect.height
    const resizeWidth = imageRect.width * scale
    const canvas = await drawImageToCanvas(imageRect.image, {
      canvasWidth: resizeWidth,
      canvasHeight: resizeHeight
    })
    return canvas.toDataURL(contentType)
  }
}
